import React from 'react';

interface Props {
  firstName: string;
  lastName: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const SIZE_CLASSES = {
  sm: { box: 'h-8 w-8',   text: 'text-xs' },
  md: { box: 'h-10 w-10', text: 'text-sm' },
  lg: { box: 'h-12 w-12', text: 'text-base' },
  xl: { box: 'h-16 w-16', text: 'text-xl' },
} as const;

export const InitialsAvatar: React.FC<Props> = ({
  firstName,
  lastName,
  size = 'md',
  className = '',
}) => {
  const initials =
    `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || '?';

  const { box, text } = SIZE_CLASSES[size];

  return (
    <div
      className={`${box} ${text} rounded-full flex items-center justify-center flex-shrink-0 font-bold text-white select-none bg-ink-700 ${className}`}
      aria-label={`${firstName} ${lastName}`}
    >
      {initials}
    </div>
  );
};
